export default __webpack_public_path__ + "static/media/blank-profile.2fda6558.png";